/* eslint-disable import/prefer-default-export */

export const SIM_ACTIVATION = {
  RESET: 0,
  LOADING: 1,
  UPDATE: 2,
  ERROR: 3,
  START_LOADING: 4,
};

export const defaultSimActivationState = {
  loading: false,
  connections: [],
  error: '',
};

export const eDataCenterStateAction = {
  UPDATE: 'DATA_LATENCY_UPDATE',
  LOADING: 'DATA_LATENCY_LOADING',
  ERROR: 'DATA_LATENCY_ERROR',
  RESET: 'DATA_LATENCY_RESET',
  RESET_LOADING: 'DATA_LATENCY_RESET_LOADING',
};

export const defaultDataCenterState = {
  data: {
    chPingAvg: '',
    laPingAvg: '',
  },
  error: '',
  loading: false,
};

export const dataCenterMockResponse = {
  chPingAvg: '78.188',
  laPingAvg: '13.774',
  timeUpdated: '2022-08-17 07:10:17.36242436 +0000 UTC',
};
